global.CROP_THUMBNAILS_VUE = {
	app:null,//will be initialized in modal/modal.js
	components : {}
};
